import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";

import FormFieldText from "../FormField/FormFieldText";
import FormFieldRange from "../FormField/FormFieldRange";
import {
  optionsReturn,
  optionsReturnForForm,
} from "../../utilities/searchChar";
import FormFieldMultiText from "../FormField/FormFieldMultiText";
import { getTreeOptions } from "../../actions/treeDetail";

class DownloadFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      genusOptions: [],
      familyOptions: [],
      missingInfo: optionsReturn(
        this.props.parentComponent.totalCharacteristics
      ),
    };

    console.log("Download Filters constructor", this.state);
  }

  async componentDidMount() {
    try {
      console.log("DownloadFilter: in componentDidMount!!\n");
      let genusList = await getTreeOptions("genus");
      let familyList = await getTreeOptions("family");

      this.setState({
        genusOptions: optionsReturnForForm(genusList),
        familyOptions: optionsReturnForForm(familyList),
      });
    } catch (err) {
      console.error(`components.DownloadFilters.componentDidMount: ${err}`);
    }
  }

  ToggleButton() {
    this.setState({ textflag: !this.state.textflag });
  }

  optionsMissingInfo = () => {
    try {
      return this.state.missingInfo;
    } catch (err) {
      console.log(`components.DownloadFilters.optionsMissingInfo: ${err}`);
    }
  };

  render() {
    let parentComponent = this.props.parentComponent;
    return (
      <Container className="search-by-char-card--download-filters">
        <Row>
          <Col lg={{ span: 6 }}>
            <FormFieldText
              title="Genus"
              field="genus"
              options={this.state.genusOptions}
              parentComponent={parentComponent}
            />
          </Col>

          <Col lg={{ span: 6 }}>
            <FormFieldText
              title="Family"
              field="family"
              options={this.state.familyOptions}
              parentComponent={parentComponent}
            />
          </Col>

          <Col lg={{ span: 6 }}>
            <FormFieldRange
              title="Photos"
              minField="minPhotos"
              maxField="maxPhotos"
              options={{
                0: "0",
                10: "10",
                20: "20",
                30: "30",
                40: "40",
                50: "50",
                60: "60",
              }}
              parentComponent={parentComponent}
            />
          </Col>

          {!this.state.textflag && this.props.text}
          <Col lg={{ span: 6 }}>
            <FormFieldMultiText
              title="Missing Info?"
              field="missingInfo"
              options={this.optionsMissingInfo()}
              parentComponent={parentComponent}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DownloadFilters;
